// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__7-xpr","footer":"ModalFilter_footer__2_B5F"};